<template>
  <div class="input-number-box">
    <div class="input-number-sub">
      <img
        class="opera-icon"
        :src="iconLeft"
        @click="handleLeftClick"
      >
    </div>
    <div
      class="input-number"
      @click="handleMiddleClick"
    >
      {{ value }}
    </div>
    <div class="input-number-add">
      <img
        class="opera-icon"
        :src="iconRight"
        @click="handleRightClick"
      >
    </div>
  </div>
</template>

<script>
import IconAdd from '@/assets/img/chargingVoucher/icon-add.png';
import IconAddDisabled from '@/assets/img/chargingVoucher/icon-add-disabled.png';
import IconSub from '@/assets/img/chargingVoucher/icon-sub.png';
import IconSubDisabled from '@/assets/img/chargingVoucher/icon-sub-disabled.png';

export default {
  name: 'InputNumber',
  props: {
    value: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER
    },
    min: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },
  computed: {
    isMin() {
      return this.value <= this.min;
    },
    iconLeft() {
      return this.isMin ? IconSubDisabled : IconSub;
    },
    isMax() {
      return this.value >= this.max;
    },
    iconRight() {
      return this.isMax ? IconAddDisabled : IconAdd;
    }
  },
  methods: {
    handleLeftClick() {
      if (this.isMin) {
        this.$toast(`购买数量不能低于 ${this.min}`);
        return;
      }
      this.$emit('left');
    },
    handleRightClick() {
      if (this.isMax) {
        this.$toast(`购买数量不能高于 ${this.max}`);
        return;
      }
      this.$emit('right');
    },
    handleMiddleClick() {
      this.$emit('middle');
    }
  }
};
</script>

<style lang="scss" scoped>
.input-number-box {
  display: flex;
  align-items: center;
  justify-content: space-around;
  min-width: 180px;
  height: 48px;
  border: 1px solid rgba(153, 153, 153, 1);
  border-radius: 12px;
  flex-shrink: 0;

  & > div {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 16px;
  }
  .input-number {
    font-size: 30px;
    color: #383838;
    text-align: center;
    font-weight: 400;
    border-left: 1px solid rgba(153, 153, 153, 1);
    border-right: 1px solid rgba(153, 153, 153, 1);
    height: 100%;
  }
  .opera-icon {
    object-fit: contain;
    height: 24px;
    width: 24px;
  }
}
</style>
